<script>
export default {
  name: 'LoadFonts',
}
</script>

<template>
  <p class="font-display">
    <span class="font-noto-sans">1</span>
    <span class="font-noto-serif">2</span>
    <span class="font-zen-maru">3</span>
    <span class="font-train-one">4</span>
    <span class="font-yomogi">5</span>
    <span class="font-sacramento">6</span>
    <span class="font-cabin-condensed">7</span>
  </p>
</template>

<style lang="scss" scoped>
@import 'load-fonts.scss';
</style>
